import { supportApi } from 'yxt-biz-pc/packages/api';
import { AIBOXAPPID } from './config';

export const getStaticBaseUrl = () => {
  if (window.feConfig && window.feConfig.common && window.feConfig.common.staticBaseUrl) {
    return window.feConfig.common.staticBaseUrl;
  }
  return 'https://stc.yxt.com/';
};

/**
 * 获取aibox应用信息
 */
export const getAppInfo = () => {
  return supportApi.get('aibox/app/detail', {
    appId: AIBOXAPPID
  });
};

export const getRecordHistory = (userId) => {
  return supportApi.get('aibox/qa/askRecordHistory', {
    userId
  });
};

/**
 * 创建会话
 * @param {string} name
 * @returns
 */
export const createSession = (name) => {
  return supportApi.get('aibox/app/topic', {
    appId: AIBOXAPPID,
    name
  });
};

/**
 * @desc 反馈单条数据情况
 * @param {Object} data
 * @param {string} data.id recordId
 * @param {number} [data.isCorrect] 解决 1 未解决 2
 * @param {string} [data.reason] 反馈内容
 * @returns
 */
export const feedbackItem = (data) => {
  return supportApi.post('aibox/aiAsk/feedback', {
    ...data,
    commentAccountNo: localStorage.getItem('username')
  });
};

/**
 * @desc 反馈情况
 * @param {string} topicId
 * @param {number} isResolved 0没啥用 1有帮助
 * @returns
 */
export const feedback = (topicId, isResolved) => {
  return supportApi.post('aibox/feedback', {
    topicId,
    isResolved
  });
};

/**
 * @desc 获取示例问题 一页6个
 * @param {number} page
 * @returns
 */
export const getExampleQuestion = (page) => {
  return supportApi.get('aibox/qa/hotContent', {
    page
  });
};

/**
 * @desc 获取示例问题
 * @param {Object} data
 * @returns
 */
export const getThoughtQuestion = (data) => {
  return supportApi.post('/center/contents/global-search', data);
};
